import { render, staticRenderFns } from "./MintPanel.vue?vue&type=template&id=3ca3c03d&"
import script from "./MintPanel.vue?vue&type=script&lang=js&"
export * from "./MintPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports